<template>
  <div @click="onClick()" >
    <div v-if="!isReady">
      <i class="fa-solid fa-spinner fa-spin-pulse"></i> Loading...
    </div>
    <div v-else style="border-bottom: solid 1px #6e9cbd; overflow-x: scroll!important" class="align-items-center detail-row-actions internal-detail-row">
              <table class="table internal-detail-table">
                  <thead>
                      <tr class="blue text-light" style="background: #5D95BE">
                       <!--  -->
                        <th v-for="(columnData,index) in columnsDetails" :key="index"
                            style=" color: white; width:200px; min-width:200px;">
                            <div v-if="columnData.name ==='__checkbox'"  :class="columnData.dataClass">
                                <input type="checkbox" value="1">
                            </div>

                            <div v-else-if="columnData.name === '__slot:actions'"></div>

                            <small v-else >{{columnData.title }}</small>
                        </th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr class="align-items-center detail-row-actions" v-for="(rowData,index) in rowsDetails" :key="index" :class="index % 2 == 0 ? 'bg-light' : ''">
                          <td v-for="(columnData, indexData) in columnsDetails" :key="indexData" style="width:200px; min-width:200px;">
                            <div v-if="columnData.name ==='__checkbox'" :class="columnData.dataClass">
                              <input type="checkbox" :value="columnData.id">
                            </div>
                            <div v-else-if="columnData.name === '__slot:actions'" class="detail-custom-actions" >

                              <button v-for="(buttonData,key) in rowData['__slot:actions']"
                                      :type="buttonData.type"
                                      :class="buttonData.classButton"
                                      v-bind:key="key"
                                      :disabled=buttonData.disabled
                                      @click="handleAction(buttonData, rowData, rowData.id)"
                              >
                                <i :class="buttonData.icon"></i>
                              </button>
                            </div>
                            <div v-else-if="columnData.name === 'modelInfoBox' " v-html="rowData[columnData.name]"></div>
                            <div v-else class="detail-row-title" :title="rowData[columnData.name]">
                              <label v-if="indexData === 0 && rowData['icon'] != null">
                                <i
                                    :class='"fas "+rowData["icon"]'
                                    :style="rowData['iconColor']"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    :title="rowData['tooltip']"
                                ></i>
                              </label>

                              {{ croptText(rowData[columnData.name],30) }}
                            </div>                          
                          </td>
                      </tr>
                  </tbody>
              </table>
        </div>
  </div>
</template>

<script>
  export default {
      mounted() {
          this.getRowData();
      },
      props: {
          rowData: {
              type: Object,
              required: true
          },
          rowIndex: {
              type: Number
          },
          fake_first_column :{
              type: Boolean,
              required: false,
              default : true
          }
      },
    data() {
      return {
        isReady : false,
        columnsDetails : [],
        rowsDetails : [],

      };
    },
      methods: {
          handleAction(buttonData, rowData) {

            switch (buttonData.actionType) {
                case "sidebar":
                  this.actionSidebar(buttonData, rowData);
                break;
                case "popup":
                  this.actionPopup(buttonData, rowData);
                break;
                case "delete":
                  this.actionDelete(buttonData, rowData);
                break;
            }
            //maybe coming soon the others action
          },
          getRowData(){
            //call axios for datas
            axios.get(this.rowData.detailRowUrl)
                .then((response) => {
                  this.columnsDetails = response.data.columnsDetails;
                  this.rowsDetails = response.data.rowsDetails;
                  this.isReady = true;

                   setTimeout(function(){
                      let width = $("#vue_table_component").css("width");
                      $(".internal-detail-row").css("width", width);
                      $(".internal-detail-row").parent().parent().css("padding", 0)

                  }, 140);

                }).catch(function(error){
              console.error(error);


            })
          },
          onClick (event) {                
          },
          croptText(text,len) {
            if(text){
              if(text.length >len ){
                return text.substring(0,len) + "..."
              } else {
                return text
              }
            }
          },
          actionSidebar(buttonConfiguration, item) {

              app.__vue__.$refs.vue_sidebar.toggle(
                  decodeURI(buttonConfiguration.action),
              );
          },
          actionPopup(buttonConfiguration, item) {
              console.log(buttonConfiguration, item);
              app.__vue__.$refs.vue_popup.toggle(
                 item.kpiName, decodeURI(buttonConfiguration.action),
              );
          },
          actionDelete(buttonConfiguration, item) {
            Vue.swal
                .fire({
                  title: "Are you sure?",
                  text: "You won't be able to revert this!",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes, delete it!",
                })
                .then((result) => {
                  if (result.value) {
                    axios
                        .delete(
                            buttonConfiguration.action,
                        )
                        .then((data) => {
                          this.getRowData();
                        })
                        .catch((error) => {
                          if (error.response.status == 405) {
                            Vue.swal.fire({
                              title: error.response.data.advice.title,
                              html: error.response.data.advice.html,
                              icon: "error",
                            });
                          } else if (error.response.status == 403) {
                            Vue.swal.fire({
                              title: error.response.data.advice.title,
                              html: error.response.data.advice.html,
                              icon: "warning",
                            });
                          } else {
                            location.reload();
                          }
                        });
                    }
                });
          },

      },
  }
</script>

<style lang="scss" scoped>

table {
  table-layout: auto !important;
}

.internal-detail-row {
position: relative;
/* left: -19px;
top: -9px; */
width: 100%;
&::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
&::-webkit-scrollbar-track {
  box-shadow: none; 
  border-radius: 10px;
}
&::-webkit-scrollbar-thumb {
  background: #1767a2; 
  border-radius: 10px;
}
&::-webkit-scrollbar-thumb:hover {
  background: #1767a2; 
}  
}

.detail-row-actions {
  font-size: 12px;
}


.detail-custom-actions  {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  width: auto;
}
/*   .detail-row-actions .col:nth-of-type(2) {
  flex-basis: 80px;
  flex-grow: 0;
  flex-shrink: 0;
}

.detail-row-actions .col:nth-of-type(1) {
  flex-basis: 210px;
  flex-grow: 0;
  flex-shrink: 0;
} */
</style>